// 获取推荐服务
export function getRecommendList(data) {
  return data.request({
    url: `${data.serveUrl}v1/service/recommend/month/list?showPublic=false`,
    method: "get",
    headerType: data.header
  });
}

// 获取最近使用的服务
export function getRecentList(data) {
  return data.request({
    url: `${data.serveUrl}v1/service/lastUse/list`,
    method: "get",
    headerType: data.header
  });
}

// 保存服务为最近使用服务
export function postRecentServe(data) {
  return data.request({
    url: `${data.serveUrl}v1/service/useTime/save?id=${data.id}`,
    method: "get",
    headerType: data.header
  });
}

// 获取服务标签
export function getServiceTagList(data) {
  return data.request({
    url: `${data.serveUrl}v1/service/tag/list?code=${data.code}`,
    method: "get",
    headerType: data.header,
    showPublicServe: data.showPublicServe
  });
}

// 获取服务列表数据
export function getServiceList(data) {
  return data.request({
    url: `${data.serveUrl}v1/service/list?kw=${data.keyWord}&showPublic=${data.showPublic}`,
    method: "post",
    data: data.data || {},
    params: data.params || {},
    headerType: data.header
  });
}

// 获取用户收藏的服务或应用
export function getCollectionService(data) {
  return data.request({
    url: `${data.serveUrl}v1/service/collect/list`,
    method: "get",
    headerType: data.header
  });
}

// 收藏 - 取消收藏单个服务
export function changeCollectService(data) {
  return data.request({
    url: `${data.serveUrl}/v1/service/collectCancelService?id=${data.id}&type=${
        data.collect
    }`,
    method: "get",
    headerType: data.header
  });
}

// 获取服务办事指南
export function getBusinessGuide(data) {
  return data.request({
    url: `${data.serveUrl}v1/service/workFlowInfo?serviceId=${data.serviceId}`,
    method: "get",
    headerType: data.header
  });
}
// url: `${data.serveUrl}v1/service/workFlowInfo?serviceId=${data.serviceId}`,

// 获取关联服务信息
export function getBusinessGuideFU(data) {
  return data.request({
    url: `${data.serveUrl}v1/service/getServiceInfo?id=${data.serviceId}`,
    method: "get",
    headerType: data.header
  });
}
// 客服查询热门问题
export function getHotQuestionList(data) {
  return data.request({
    url: `${data.serveUrl}kf/getHotQuestionList`,
    method: "post",
    headerType: data.header
  });
}

// 客服对话
export function getKfChat(data) {
  return data.request({
    url: `${data.serveUrl}kf/chat?inputTxt=${data.inputTxt}&knowledgeId=${data.knowledgeId}&sessionId=${data.sessionId}`,
    method: "post",
    headerType: data.header
  });
}

// 获取历史对话记录
export function getDialogList(data) {
  return data.request({
    url: `${data.serveUrl}kf/getDialogList?pageNo=${data.pageNo}&pageSize=${data.pageSize}`,
    method: "post",
    headerType: data.header
  });
}

// 客服评论
export function postCommentQuestion(data) {
  return data.request({
    url: `${data.serveUrl}kf/commentQuestion?id=${data.id}&commentType=${data.commentType}`,
    method: "post",
    headerType: data.header
  });
}
export function getEvaluationData(data) {
  return data.request({
    url: `${data.serveUrl}v1/evaluate/findEvaluateList?serviceId=${data.serviceId}&pageSize=${data.pageSize}&pageNo=${data.pageNo}`,
    method: "get",
    headerType: data.header
  });
}
export function saveEvaluationData(data) {
  return data.request({
    url: `${data.serveUrl}v1/evaluate/saveEvaluate`,
    method: "post",
    headerType: data.header,
    data: data.obj
  });
}
export function getEvaluationScore(data) {
  return data.request({
    url: `${data.serveUrl}v1/evaluate/getEvaluateInfo?serviceId=${data.serviceId}`,
    method: "get",
    headerType: data.header
  });
}
export function recordingTimes(data) {
  return data.request({
    url: `${data.serveUrl}v2/service/writeHandleBehavior?id=${data.id}`,
    method: "post",
    headerType: data.header
  });
}

